import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import SendEmail from '../Components/SendEmail.component';

const MercosurCertificate = () => {
  //   const { user } = useAuthDataContext();
  const { loading, vehicle, policy, getPolicyById } = useVehiclesContext();
  const { id }: any = useParams();
  const history = useHistory();
  const { user } = useAuthDataContext();

  useEffect(() => {
    dataLayerPush('Documentacion_certificado_mercosur', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id) {
      if (policy.id !== Number(id)) {
        getPolicyById(id);
      }
    } else {
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const COUNTRIES = [
    'Argentina',
    'Brasil',
    'Paraguay',
    'Uruguay',
    'Chile',
    'Bolivia',
  ];

  return Object.keys(policy).length ? (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando póliza'}></Loader>
      </Box>
      <SubHeader
        content={
          <>
            <Typography>Certificado del mercosur</Typography>
            <Typography variant="h6" color="primary">
              {vehicle.brand +
                ' ' +
                vehicle.model.split(' ')[0] +
                ' ' +
                vehicle.year +
                ' / ' +
                vehicle.license_plate}
            </Typography>{' '}
            <Typography variant="caption">
              Este documento es necesario para realizar viajes en países del
              mercosur y limitrofes.
            </Typography>
          </>
        }
        actions={<SendEmail documentType={'mercosur_certificate'}></SendEmail>}
      ></SubHeader>

      <Grid container justify="center">
        <Grid item xs={11} sm={11} lg={11}>
          {/* VEHCILE INFO */}
          <Grid container>
            <Grid item xs={12}>
              <Box my={3}>
                <Typography variant="body2">
                  Si estás por salir del país tené en cuenta que vas a
                  necesitar:
                </Typography>
                <List aria-label="detalles">
                  <ListItem>
                    <ListItemIcon>
                      <OkIcon />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography variant="body2">DNI y Pasaporte</Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <OkIcon />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography variant="body2">
                          Este documento (Certificado de MERCOSUR)
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <OkIcon />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography variant="body2">
                          Cédula de Identidad Provincial (según acuerdo)
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box mb={2}>
                <Typography variant="body2">
                  Esta credencial sirve para circular asegurado en:
                </Typography>
              </Box>
              <Box my={2}>
                <Grid container>
                  {COUNTRIES.map((c: string, index: number) => (
                    <Grid item xs={6} sm={4} key={1}>
                      {c}
                    </Grid>
                  ))}
                </Grid>
              </Box>
              <Box my={2}>
                <Typography variant="caption">
                  La vigencia de esta credencial, se encuentra condicionada a la
                  vigencia del seguro, que se renueva anualmente de forma
                  automática mediante el pago del premio.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  ) : null;
};

export default MercosurCertificate;
